import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import React, { useEffect, useRef, useState } from "react";
import { Fetch, ILazyParams } from "../../shared/Fetch";
import { EmptyNonPerformingVendor } from "./EmptyNonPerformingVendor";
import { IModel1 } from "./NonPerformingVendor";
import { EmptyFilter, Filter, IFilterContactPerson } from "./Filter";
import { JVCheck } from "../../shared/JVCheck";
import { format } from "date-fns";
import { ILogin, IPermissionProps } from "../../models/Login";
import { Accordion, AccordionTab } from "primereact/accordion";
import { IClientTnfr } from "../clientTransfer/ClientTnfr";
import { TnfrHistory } from "../nonPerformingVendor/TnfrHistory";
import { MutualClientTransfer } from "../nonPerformingVendor/MutualClientTransfer";

import { MultipleTransfer } from "../nonPerformingVendor/MultipleTransfer";
import { MultipleTransferSales } from "../nonPerformingVendor/MultipleTransferSales";
import { MultipleTransferHead } from "../nonPerformingVendor/MultipleTransferHead";
import { Mail } from "../nonPerformingVendor/Mail";
import { Dialog } from "primereact/dialog";
import { JVDropdown } from "../../shared/JVDropdown";
import { Share } from "./Share";
import { ISalesAllocation } from "../salesAllocation/Table";
import { TableHistory } from "./TableHistory";



interface Iprops {
    setModal: (modal: IModel1) => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void,
    permissions: IPermissionProps
}

export interface INVP {
    vendor_Company_ID?: number,
    vendor_Company_Name?: string,
    company_Name?: string,
    totalReq?: number
}

export const Table = (props: Iprops) => {

    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<INVP>, loading: boolean });
    const [totalRecords, setTotalRecords] = useState(0);
    const [filters, setFilters] = useState<IFilterContactPerson>(EmptyFilter);
    const [selectedClients, setSelectedClients] = useState<Array<number>>([]);
    const [share,setShare] = useState({singleData:{}, open: false} as {singleData:{}, open: boolean});
    const [tablehistory, setTablehistory] = useState({ tablehistory: [], loading: false } as { tablehistory: Array<ISalesAllocation>, loading: boolean });
    const[ history,setHistory]=useState({Data:{}, open: false} as {Data: ISalesAllocation, open: boolean})

    const [rowCountMax,setRowCountMax] = useState(0);

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const dt = useRef<any>(null);
    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 0,
        page: 1,
        sortField: 'contact_Person_ID',
        sortOrder: -1
    });
    // const [filter, setFilter] = useState(false);
    // const hideFilterDialog = () => {
    //     setFilter(false);
    // };
    const [tHistory, setTHistory] = useState({ contactPerson: 0, open: false });
    const hideTHistory = () => {
        setTHistory({ contactPerson: 0, open: false });
    }
    const [transfer, setTransfer] = useState<{ salesPerson_Company_ID?: number, contactPerson?: number, salesManagerFrom?: number, contactPersonName?: string, open?: boolean }>({ salesPerson_Company_ID: 0, contactPerson: 0, contactPersonName: '', open: false });
    const hideTransfer = () => {
        setTransfer({ salesPerson_Company_ID: 0, contactPerson: 0, contactPersonName: '', open: false });
    }
    const [mail, setMail] = useState({ data: [], open: false } as {
        data: Array<{ contactPersonID: number, contactPersonName: string, contactPersonEmail: string }>
        open: boolean
    });
    const hideMailDialog = () => {
        setMail({ data: [], open: false });
    };
    const [mct, setMCT] = useState(false);
    const hideMCTDialog = () => {
        setMCT(false);
    };

    useEffect(() => {
        if (lazyParams.rows) {
            // getTableDataCount();
            loadTableData();
        }
        setSelectedClients([]);
    }, [lazyParams, filters, props.reload]);

    useEffect(() => {
        loadRowsCount();
    }, []);
    useEffect(() => {
        if(rowCountMax > 0) getTableDataCount();
    }, [rowCountMax]);

    const onPage = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const onSort = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const loadRowsCount = async () => {
        const response = await Fetch("Website_Settings/getSetting", "GET", null, `settingKey=${"CP-LIST"}`, props.toast);
        if (response) {
            const rowsCount = parseInt(await response.text(), 10);
            setLazyParams((lp) => {
                return { ...lp, rows: rowsCount }
            });
            setRowCountMax(rowsCount);
        } else {
            setLazyParams((lp) => {
                return { ...lp, rows: 0 }
            });
            setRowCountMax(0);
        }
    }

    const getTableDataCount = async () => {
        let FilterBackend: any = {
            fromDate: filters.fromDate,
            toDate: filters.toDate,
            branch_ID: undefined,
            company_ID: undefined,
            vendor_Company_ID: filters.company?.vendor_Company_ID,
            city_ID: filters.city_ID,
            state_ID: filters.state_ID,
            email: filters.email,
            majorSkill: filters.majorSkill,
            salesPerson_Company_ID: filters.salesPerson_Company_ID,
            salesPerson_Branch_ID: filters.salesPerson_Branch_ID,
            sales_Person_Id: filters.sales_Person_Id,
        };
        const response = await Fetch("NonPerformingVendor/count", "GET", null, `filter=${JSON.stringify(FilterBackend)}`, props.toast);
        if (response) {
            const count: number = parseInt(await response.text(), 10);
            setTotalRecords(count);
        }
    }

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
    
        let FilterBackend: any = {
            fromDate: filters.fromDate,
            toDate: filters.toDate,
            branch_ID: undefined,
            company_ID: undefined,
            vendor_Company_ID: filters.company?.vendor_Company_ID,
            city_ID: filters.city_ID,
            state_ID: filters.state_ID,
            email: filters.email,
            majorSkill: filters.majorSkill,
            salesPerson_Company_ID: filters.salesPerson_Company_ID,
            salesPerson_Branch_ID: filters.salesPerson_Branch_ID,
            sales_Person_Id: filters.sales_Person_Id,
        };
        const response = await Fetch("NonPerformingVendor", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}&filter=${JSON.stringify(FilterBackend)}`, props.toast);
        if (response) {
            const data: any = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    }

    const openNew = () => {
        props.setModal({ open: true, singleData: EmptyNonPerformingVendor });
    };

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                </div>
            </React.Fragment>
        );
    };

    // const sendMail = () => {
    //     if (selectedClients.length === 0) {
    //         props.toast.current.show({ severity: 'error', detail: "Select Client Contact Person.", life: 3000 });
    //     } else if (selectedClients.length > 20) {
    //         props.toast.current.show({ severity: 'error', detail: "You can't send mail to more than 20 contacts at once, please select less.", life: 3000 });
    //     } else {
    //         const _data: Array<{ contactPersonID: number, contactPersonName: string, contactPersonEmail: string }> = [];
    //         tableData.tableData.forEach((td) => {
    //             if (td.contact_Person_Id && td.contact_Person_Name && td.contact_Person_EmailID && selectedClients.includes(td.contact_Person_Id)) {
    //                 _data.push({ contactPersonID: td.contact_Person_Id, contactPersonName: td.contact_Person_Name, contactPersonEmail: td.contact_Person_EmailID });
    //             }
    //         });
    //         setMail({ data: _data, open: true });
    //     }
    // };

    const rightToolbarTemplate = () => {
        return (
            <>
                <React.Fragment>
                    {/* <Button label="SendMail" icon="pi pi-envelope" className="p-button-info mr-2" onClick={sendMail} /> */}
                </React.Fragment>
                <React.Fragment>
                    <Button label="MCT" icon="pi pi-share-alt" className="p-button-info mr-2" onClick={() => setMCT(true)} />
                </React.Fragment>
                {props.permissions.is_Export && <React.Fragment>
                    <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />
                </React.Fragment>}
            </>
        );
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Manage Non Performing Vendor</h5>
            {/* <span className="block mt-2 md:mt-0 p-input-icon-left">
                <Button icon="pi pi-filter" onClick={() => setFilter(true)} className="p-button-rounded p-button-secondary ml-2" aria-label="Filter" />
            </span> */}
        </div>
    );

    const selectHead = () => {
        return (
            <span onClick={() => {
                if (tableData.tableData.length === selectedClients.length) {
                    setSelectedClients([]);
                } else {
                    const temp: Array<number> = [];
                    tableData.tableData.forEach((data) => {
                        // const currentDate = format(new Date(), 'dd/MM/yyyy').toUpperCase();
                        // const lastMailDate = data.send_Date ? format(new Date(data.send_Date), 'dd/MM/yyyy').toUpperCase() : "";
                        // if (data.contact_Person_Id && currentDate !== lastMailDate) temp.push(data.contact_Person_Id)
                    });
                    setSelectedClients(temp);
                }
            }}>
                <JVCheck name="select_all_clients" defaultValue={tableData.tableData.length > 0 && tableData.tableData.length === selectedClients.length}></JVCheck>
            </span>
        );
    }
    const onSelect = (rowData: IClientTnfr, currentDate: string, lastMailDate: string) => {
        if (rowData.contact_Person_Id) {
            if (selectedClients.includes(rowData.contact_Person_Id)) {
                const temp = selectedClients.filter((t) => { return t !== rowData.contact_Person_Id });
                setSelectedClients(temp);
            } else {
                if (currentDate === lastMailDate) {
                    props.toast.current.show({ severity: 'info', detail: `You have already send a mail today to "${rowData.contact_Person_Name}"`, life: 3000 });
                } else {
                    const temp = [...selectedClients];
                    temp.push(rowData.contact_Person_Id);
                    setSelectedClients(temp);
                }
            }
        }
    }
    const select = (rowData: IClientTnfr) => {
        const currentDate = format(new Date(), 'dd/MM/yyyy').toUpperCase();
        const lastMailDate = rowData.send_Date ? format(new Date(rowData.send_Date), 'dd/MM/yyyy').toUpperCase() : "";
        return (<>{currentDate === lastMailDate ?
            <Button icon="pi pi-check" disabled className="p-button-rounded p-button-success p-button-text" />
            : <span onClick={() => onSelect(rowData, currentDate, lastMailDate)}>
                <JVCheck name={rowData.contact_Person_EmailID} defaultValue={rowData.contact_Person_Id !== undefined && selectedClients.includes(rowData.contact_Person_Id)}></JVCheck>
            </span>}</>
        );
    }

    const add_Date = (rowData: IClientTnfr) => {
        let date;
        if (rowData.add_Date) date = format(new Date(rowData.add_Date), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const reqPostedDate = (rowData: IClientTnfr) => {
        let date;
        if (rowData.reqPostedDate) date = format(new Date(rowData.reqPostedDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const lastMail = (rowData: IClientTnfr) => {
        let date;
        if (rowData.send_Date) date = format(new Date(rowData.send_Date), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        let bg = rowData.send_Status ? "green" : "red";
        return (<><div style={{ height: '10px', width: '10px', borderRadius: '50%', background: bg }}> </div>{date}</>);
    };
    const openTHistory = (rowData: IClientTnfr) => {
        rowData.contact_Person_Id && setTHistory({ contactPerson: rowData.contact_Person_Id, open: true });
    }
    const contact_Person_Name = (rowData: IClientTnfr) => {
        return (
            <span onClick={() => openTHistory(rowData)}
                className="cursor-pointer text-cyan-700 underline">
                {rowData.contact_Person_Name}
            </span>
        );
    }
    const clientTransferBtn = (rowData: IClientTnfr) => {
        // console.log(rowData);
        return (
            <div className="actions">
                <Button icon="pi pi-share-alt" className="p-button-rounded p-button-success p-button-text mr-1"
                    onClick={() => {
                        if (rowData.contact_Person_Id && rowData.contact_Person_Name)
                            setTransfer({ salesPerson_Company_ID: rowData.salesPerson_Company_Id, contactPerson: rowData.contact_Person_Id, salesManagerFrom: rowData.sales_Person_Id, contactPersonName: rowData.contact_Person_Name, open: true });
                    }} />
            </div>
        );
    };

    const hideDialog=()=>{
        setShare({singleData: {}, open: false});
        
    }
    // const loadTablehistory = async (rowData: ISalesAllocation) => {
    //     const response = await Fetch("NonPerformingPVAllocation", "GET", null, `Vendor_Company_ID=${rowData.vendor_Company_ID}&Company_ID=${rowData.company_ID}`, props.toast);
    //     if (response) {
    //         const data: Array<ISalesAllocation> = await response.json();
    //         setTablehistory({ tablehistory: data, loading: false });
    //     } else setTablehistory({ tablehistory: tablehistory.tablehistory, loading: false });
    // };

    // const converted_Type = (rowData: ISalesAllocation) => {
    //     return (
    //         <span className="" >{rowData.converted ? "Yes" : "No"}</span>
    //     );
    // };
    const hideHistory = () => {
        setHistory({ Data: {}, open: false });
    }
    const openHistory = (rowData: ISalesAllocation) => {
        setHistory({ Data: rowData, open: true });
    }
    const pvHistory = (rowData: ISalesAllocation) => {
        return (
            <Button onClick={() => openHistory(rowData)} icon="pi pi-history" className="p-button-rounded p-button-secondary p-button-text" aria-label="History" />
        );
    };

    return (
        <>
            {/* <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar> */}
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter filters={filters} setFilters={(filters: IFilterContactPerson) => setFilters(filters)} />
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" } }
                resizableColumns showGridlines columnResizeMode="expand" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                ref={dt} size="small" stripedRows scrollable scrollHeight="70vh"
                value={tableData.tableData} lazy dataKey="id"
                paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[10, 20, 50, rowCountMax]}
                totalRecords={totalRecords} onPage={onPage}
                onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                emptyMessage="No Client Contact Person found."
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                header={header}
                loading={tableData.loading}
            >
                <Column header="SN." body={(data, options) => options.rowIndex + 1}  style={{ maxWidth: "4rem" }} />
                <Column field="vendor_Company_Name" header="Vendor Company Name" style={{ minWidth: "15rem" }} />
                <Column field="company_Name" header="Company Name" />
                <Column field="totalReq" header="Req" />
                <Column field="totalSub" header="Sub" />
                <Column field="totalsubEnd" header="Sub End Client" />
                <Column field="totalECI" header="ECI" />
                <Column field="totalPO" header="PO" />
                <Column header="Action" body={(rowData) => <Button icon="pi pi-share-alt" className="p-button-rounded p-button-success p-button-text mr-1 text-blue-400" onClick={() => {
                    setShare({ singleData: rowData, open: true });
                    
                }} />} />
              <Column field="pvIHistory" header="PV History" body={pvHistory} />
            </DataTable>
              <Share open={share.open} singleData={share.singleData} hideDialog={hideDialog} toast={props.toast} />
              <TableHistory singleData={history.Data} open={history.open} hideDialog={hideHistory} toast={props.toast} />
            
        </>
    );
}
